<template>
  <!-- 状态选择 -->
  <div class="v-status v-status__flex flex-end">
    <div class="v-status__flex">
      <p class="v-status__title">{{ statusName }}</p>
      <div
        v-for="status in statusList"
        :key="status.id"
        :class="['status-tag', { 'status-active': activeNum == status.id }]"
        @click="checkStatus(status)"
      >
        {{ status[props] }}
      </div>
    </div>
    <slot name="check-all"></slot>
  </div>
</template>

<script>
import i18n from '@/utils/i18n';

export default {
  name: 'VStatus',
  props: {
    statusName: {
      type: String,
      default: i18n.t('common.status'),
    },
    statusList: {
      type: Array,
      default: () => [],
    },
    active: {
      // 默认待状态值
      type: [Number, String],
      default: '',
    },
    props: {
      // 状态名称
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      activeNum: this.active,
    };
  },
  methods: {
    checkStatus(item) {
      this.activeNum = item.id;
      this.$emit('click', item);
    },
  },
};
</script>

<style lang="scss">
.v-status {
  margin-bottom: 10px;
  &__flex {
    @include flex;
    justify-content: space-between;
  }
  &__title {
    min-width: 64px;
    margin-right: 12px;
    text-align: right;
    font-size: $font14;
    color: $normalText;
  }
  .status-tag {
    padding: 5px 12px;
    margin-right: 12px;
    background: $bottomBg;
    color: $headerText;
    border: 1px solid $bottomBg;
    font-size: $font12;
    @include radius;
    cursor: pointer;
  }
  .status-active {
    background: $tabNormalBg;
    border: 1px solid $blueHover;
  }
}
</style>
